//document.querySelectorAll('input[name=hey]')[0].value
jQuery( document ).ready(function($) {
    $("input[name='sq_foot_length'], input[name='sq_foot_width']").bind("change paste keyup", function() {
    	//console.log($("input[name='sq_foot_length']").val());

    	var total = $("input[name='sq_foot_width']").val() * $("input[name='sq_foot_length']").val();
    	//sq_foot_total
    	$("input[name='sq_foot_total']").val(total);

        $("#size_length").val($("input[name='sq_foot_length']").val());
        $("#size_width").val($("input[name='sq_foot_width']").val());
        $('input[name="quantity"]').val(Math.ceil(total));
    });


    $(".calculator_pop_up_openener, #calculator_pop_up, .calculator_pop_up_overlay").click(function(e) {
        $(".calculator_pop_up, .calculator_pop_up_overlay").toggle();
    });


    $(".product-form .product-form__submit").click(function(e) {

      if( !$(this).parents().hasClass('sample_product_block') ) {
        if($("#size_width").val() <= 0 || $("#size_length").val() <= 0 || $("#size_width").val() === null|| $("#size_length").val() === null ) {
          e.preventDefault();
          alert("Please enter your measurements above.")
        }
      }
    });

  
});